import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { SiteConfigurationTemplate, TagMapping } from '../../../types';
import { StatusChip } from '../StatusChip';
import { EmptySection } from '../EmptySection';
import { useTagMappingStatus } from 'src/features/sites/hooks';

type AssetsSectionProps = {
  template: SiteConfigurationTemplate;
  tagMapping: TagMapping;
};

export const AssetsSection = ({ template, tagMapping }: AssetsSectionProps) => {
  const { unmappedNames } = useTagMappingStatus(template, tagMapping);

  const rows = template.assets;
  if (!rows.length) return <EmptySection label="Assets" />;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Asset Name</TableCell>
            <TableCell>Asset Type</TableCell>
            <TableCell>Note</TableCell>
            <TableCell align="right">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((asset) => {
            const assignedTagIds = (asset.assignedTags ?? []).map((t) => t.tagIdempotencyKey);
            // Assets are always included — unmapped tags are skipped and the asset is
            // created with whatever tags are mapped. Show a note for awareness only.
            const missing = unmappedNames(assignedTagIds);

            return (
              <TableRow key={asset.id}>
                <TableCell>{asset.assetName || '—'}</TableCell>
                <TableCell>{asset.assetType || '—'}</TableCell>
                <TableCell>
                  {missing.length ? (
                    <Typography variant="caption" color="warning.main">
                      Unmapped (will be skipped): {missing.join(', ')}
                    </Typography>
                  ) : null}
                </TableCell>
                <TableCell align="right">
                  <StatusChip included={true} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
